module.exports = __webpack_public_path__ + "src/assets/img/guy_left_3.7eaba53b.png";